import { AuthEvent } from "@/features/Auth/AuthPopup/utils/constants";
import FilledTextButton from "./FilledTextButton";
import { useCheckAuth } from "@/hooks/useCheckAuth";
import { themeColors } from "@/utils/themeColors";
import { SxProps } from "@mui/system";

export const AddRatingButton = ({
    isRated,
    setRatingPopupOpen,
    sx,
}: {
    isRated: boolean;
    setRatingPopupOpen: (open: boolean) => void;
    sx?: SxProps;
}) => {
    const { checkAuth } = useCheckAuth();

    return (
        <FilledTextButton
            className="secondaryTextBold1"
            onClick={() =>
                checkAuth({
                    event: AuthEvent.RATE_ITEM,
                    onAuthSuccess: () => setRatingPopupOpen(true),
                })
            }
            sx={{
                borderWidth: 1,
                border: `1px solid ${themeColors.neutral1}`,
                height: "4rem",
                fontSize: "1.2rem",
                ...sx,
            }}>
            {isRated ? "Update rating" : "Rate it"}
        </FilledTextButton>
    );
};

export default AddRatingButton;
